const supervise = {
  superviseOrg: 'Organization',
  group: 'Group',
  correctTime: 'Join Time',
  correctPlan: 'Correct Plan',
  isBindDevice: 'Bind Device',
  absent: 'Ask Leave',
  Male: 'Male',
  male: 'male',
  female: 'female',
  name: 'Name',
  identityID: 'Identity ID',
  birthday: 'Birthday',
  phone: 'Phone',
  address: 'Address',
  fenceType: 'Fence Type',
  defaultGroup: 'Default Group',
  groupName: 'Group Name',
  groupDescription: 'Group Description',
  applyChild: 'Apply To Child',
  applyChildTip: 'Enable apply to child, The all child will inherit this set ',
  editSuperviseRule: 'Edit Supervise Rule',
  groupAliasName: 'Alias Name',
  groupNameRequired: 'group name is required',
  nameRule: 'this word must less than 30',
  aliasNameRequired: 'please input group alias name',
  descriptionRequired: 'please input group description',
  descriptionRule: 'group description must less than 200 chars',
  option: 'Options',
  locateFreq: 'Locate Frequency',
  locateFreqBase: 'WIFI/LBS positioning frequency',
  locateFreqBle: 'Bluetooth positioning frequency',
  locateFreqGps: 'GPS positioning frequency',
  autoAdjust: 'Auto Adjust Frequency',
  autoPowerUp: 'Auto Power Up',
  autoPowerDown: 'Auto Power Down',
  customLocate: 'Segment Options',
  modelLocate: 'Classification settings',
  segmentTime: 'Segment Time',
  segmentFreq: 'Segment Frequency',
  selecteTimeTip: 'please select time',
  powerTip: 'power up and power down must set togather',
  smartRule: 'Smart Rule',
  timeingName: 'Time Name',
  timeingHeart: 'Time Heart',
  time: 'Time',
  mapFence: 'Map Fence',
  inheritMapFence: 'Inherit Map Fence',
  ownedMapFence: 'Owned Map Fence',
  circle: 'Circle',
  polygon: 'Polygon',
  district: 'District',
  fenceName: 'Fence Name',
  forbidType: 'Forbid Type',
  timeOption: 'Time Option',
  center: 'Center',
  radius: 'Radius',
  newGroup: 'Create New Group',
  complete: 'Complete',
  templateName: 'Template Name',
  templateDescription: 'Template Description',
  addEntity: 'Add Entity',
  reason: 'Reason',
  preBack: 'Pre Back',
  backTip: 'if you want to prelong absent time, please end your existing statu first',
  bindEntity: 'Bind Entity',
  bindTip: 'the entity only can bind device of this orgnaiztion owned device ',
  isBinding: 'is binding',
  entityInfo: 'Entity Info',
  noPic: 'no-pic',
  editEntity: 'Edit Entity',
  personalConfig: 'Personal Option',
  groupConfig: 'Group Option',
  addTimeOption: 'Add Time Option',
  personalFence: 'Personal Fence',
  noPersonalFence: 'No personal fence have been created',
  drawFence: 'Draw Fence',
  drawByWheel: 'Draw Fence By Wheel',
  addPersonalFence: 'Add Personal Fence',
  selectDistrict: 'Select District',
  fenceCenter: 'Fence Center',
  editFence: 'Edit Fence',
  deleteFence: 'Delete Fence',
  commitEdit: 'Commit Edit',
  importEntitys: 'Import Entitys',
  downloadTemplate: 'Download Template',
  entityTemplate: 'entitys template',
  selectedValue: ' (The value can only be one of {data} ) ',
  yzkj:'Keep it turned on all the time.',
  mapType:'Map Type',
  indoorMap:'Indoor Map',
  outdoorMap:'Outdoor Map',
  selectMapTypeTip:'Please select the map type.',
  scene:'Scene',
  selectSceneTip:'Please select the scene.',
  fenceNumberTip:'The number of restricted entry fences supports the drawing of 10, and the number of restricted exit fences supports the drawing of 1.',
  locationType:'Locate Mode',
  操作成功:'Operation succeeded',
}
export default supervise
